export var MedicalInfo;
(function (MedicalInfo) {
    let Physical;
    (function (Physical) {
        Physical.types = [
            'diabetes',
            'hypertension',
            'stroke',
            'heartDisease',
            'asthma',
            'lungOrRespiratory',
            'chronicObstructive',
            'earNoseThroat',
            'muscularOrSkeletal',
            'concussion',
            'altitudeSickness',
            'neurologicalBehavior',
            'bloodDisorder',
            'faintingOrDiziness',
            'kidneyDisease',
            'seizuresOrEpilepsy',
            'abdominal',
            'thyroid',
            'skin',
            'sleep',
            'recentHospitalizations',
            'otherMentions',
            'additionalInfo'
        ];
        Physical.Details = [
            ...Physical.types,
        ];
        Physical.detailNameMap = {
            diabetes: 'Diabetes',
            hypertension: 'Hypertension',
            stroke: 'Stroke',
            heartDisease: 'Heart Disease',
            asthma: 'Asthma',
            lungOrRespiratory: 'Lung / Respiratory Disease',
            chronicObstructive: 'COPD',
            earNoseThroat: 'Ear Eye Nose Throat',
            muscularOrSkeletal: 'Muscular/Skeletal Condition',
            concussion: 'Head Injury or Concussions',
            altitudeSickness: 'Altitude Sickness',
            neurologicalBehavior: 'Neurological / Behavioral Disorder',
            bloodDisorder: 'Blood Disorder',
            faintingOrDiziness: 'Fainting Spells or Dizziness',
            kidneyDisease: 'Kidney Disease',
            seizuresOrEpilepsy: 'Seizures or Epilepsy',
            abdominal: 'Stomach/Digestive Disorder',
            thyroid: 'Thyroid Disorder',
            skin: 'Skin Disorder',
            sleep: 'Sleep Disorder',
            recentHospitalizations: 'Surgeries or Hospitalizations',
            otherMentions: 'Medical concern not listed',
            additionalInfo: 'Additional Information'
        };
    })(Physical = MedicalInfo.Physical || (MedicalInfo.Physical = {}));
    let Mental;
    (function (Mental) {
        Mental.types = [
            'addOrAdhd',
            'bipolar',
            'panicAttacks',
            'moodChanges',
            'proCounseling',
            'hospitalizations',
            'spectrumDisorder',
            'depression',
            'separationAnxiety',
            'schizophrenia',
            'anxiety',
            'ocd',
            'selfharm',
            'eatingDisorder',
            'additionalInfo'
        ];
        Mental.Details = [
            ...Mental.types,
            'otherMentions'
        ];
        Mental.detailNameMap = {
            addOrAdhd: 'ADD or ADHD',
            bipolar: 'Bipolar',
            panicAttacks: 'Panic Attacks',
            moodChanges: 'Temper / Mood Changes',
            proCounseling: 'Professional Counseling',
            hospitalizations: 'Hospitalizations',
            spectrumDisorder: `Asperger's, Autism, Spectrum`,
            depression: 'Depression',
            separationAnxiety: 'Separation Anxiety',
            schizophrenia: 'Schizophrenia / Psychosis',
            anxiety: 'Anxiety',
            ocd: 'OCD',
            selfharm: 'Self-Harm',
            eatingDisorder: 'Eating Disorder Behavior',
            otherMentions: 'Other',
            additionalInfo: 'Additional Information'
        };
    })(Mental = MedicalInfo.Mental || (MedicalInfo.Mental = {}));
    let Allergies;
    (function (Allergies) {
        Allergies.types = [
            'foodAllergies',
            'medicationAllergies',
            'otherAllergies',
            'additionalInfo'
        ];
        Allergies.Details = [
            ...Allergies.types,
        ];
        Allergies.detailNameMap = {
            foodAllergies: "Food Allergies",
            medicationAllergies: "Allergies to Medications",
            otherAllergies: "Other Allergies",
            additionalInfo: 'Additional Information'
        };
    })(Allergies = MedicalInfo.Allergies || (MedicalInfo.Allergies = {}));
    let Medication;
    (function (Medication) {
        Medication.types = [
            'medication',
            'additionalInfo'
        ];
        Medication.Details = [
            ...Medication.types,
        ];
        Medication.detailNameMap = {
            medication: "Medication",
            additionalInfo: 'Additional Information'
        };
    })(Medication = MedicalInfo.Medication || (MedicalInfo.Medication = {}));
})(MedicalInfo || (MedicalInfo = {}));
//# sourceMappingURL=index.js.map